import myUtils from '../myUtils';
import apiConfig from './apiConfig';

const apiUrl = apiConfig.configApiUrl
const webUrl = apiConfig.configWebUrl
const options = (method, body) => apiConfig.configOptions(method, body)
const callApi = (_url, _options) => apiConfig.configCallApi(_url, _options)

const sendPush = async (body) => {
    const url = `${webUrl}/push`;
    const resp = callApi(url, options('POST', body));

    return resp;
}

const createNotification = async (body) => {
    const url = apiUrl+`/notifications`;
    const resp = await callApi(url, options('POST', body));

    return resp;
}

export default {
    sendPush,
    createNotification,
}